import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { KForm, KFormInput, KFormNumber, KFormSpinner } from '@kwixeo/form-vue'
import { BCol, BFormGroup, BInputGroup, BRow, BTabs, BTab } from 'bootstrap-vue'
import moment from 'moment'

@Component({
  components: {
    KForm, KFormNumber, KFormInput, KFormSpinner,
    BFormGroup, BInputGroup, BRow, BCol, BTabs, BTab
  }
})
export default class ForecastForm extends Vue {
  @Prop({ default: null }) value!: KwixeoDashboard.Forecast|null

  private forecast: KwixeoDashboard.ForecastForm = {
    begin: new Date().getFullYear(),
    end: new Date().getFullYear(),
    datas: {}
  }

  get formAction (): string {
    let url = '/dashboard/forecast'
    if (this.value?.id) {
      url += '/' + this.value.id
    }
    return url
  }

  get formMethod (): string {
    return this.value?.id ? 'PUT' : 'POST'
  }

  get years (): number[] {
    const years = []
    for (let year = this.forecast.begin; year <= this.forecast.end; year++) {
      years.push(year)
    }
    return years
  }

  get datas (): KwixeoDashboard.ForecastDatas {
    const datas: KwixeoDashboard.ForecastDatas = this.forecast.datas
    this.years.forEach(year => {
      if (datas[year] === undefined) {
        datas[year] = {}
      }
    })
    return datas
  }

  @Watch('value', { immediate: true })
  private watchValue (value: KwixeoDashboard.Forecast|null): void {
    this.forecast = value ? JSON.parse(JSON.stringify(value)) : {
      begin: moment().format('YYYY'),
      end: moment().format('YYYY'),
      datas: {}
    }
  }

  private getMinYear (): number {
    return Number(moment().subtract(10, 'years').format('YYYY'))
  }

  private getMaxYear (): number {
    return Number(moment().add(10, 'years').format('YYYY'))
  }
}
